module.exports = __webpack_public_path__ + "img/组 10125@2x (1).0865e7da.png";